import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ProjectService } from "app/services/project/project.service";
import { UserService } from "app/services/user/user.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-legal-terms",
    templateUrl: "./legal-terms.component.html",
    styleUrls: ["./legal-terms.component.scss"],
    standalone: false
})
export class LegalTermsComponent implements OnInit, OnDestroy {
    idProject: number = 0;
    legalTermsHtml: SafeHtml = "";
    private legalType: string | null = null;
    private queryParamsSub: Subscription | null = null;

    constructor(
        private userService: UserService,
        private projectService: ProjectService,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.queryParamsSub = this.route.queryParams.subscribe((params) => {
            this.legalType = params["type"] ?? null;
            this.loadLegalTermsContent();
        });
    }

    ngOnDestroy(): void {
        this.queryParamsSub?.unsubscribe();
    }

    private loadLegalTermsContent(): void {
        const projectId = this.idProject || Number(this.projectService.getProjectId());
        if (projectId) {
            this.idProject = projectId;
            this.getLegalTerms(projectId);
            return;
        }

        this.getDataUser();
    }

    getDataUser() {
        this.userService.getDataUser().subscribe(
            (data) => {
                let json = JSON.parse(JSON.stringify(data));
                this.idProject = json.proyectos[0].id;
                this.getLegalTerms(this.idProject);
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getLegalTerms(idProject: number) {
        this.projectService.getProjectLegal(idProject, this.legalType).subscribe(
            (data) => {
                let json = JSON.parse(JSON.stringify(data));
                this.legalTermsHtml = this.sanitizer.bypassSecurityTrustHtml(json.legal ?? "");
            },
            (error) => {
                console.log(error);
            }
        );
    }
}
